import { render } from "./ButtonWithIcon.vue?vue&type=template&id=6b0fd090&scoped=true"
import script from "./ButtonWithIcon.vue?vue&type=script&lang=js"
export * from "./ButtonWithIcon.vue?vue&type=script&lang=js"

import "./ButtonWithIcon.vue?vue&type=style&index=0&id=6b0fd090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0fd090"]])

export default __exports__